import { connect } from 'react-redux';
import { actions } from '../actions/attachmentsPreviewModal';
import AttachmentsPreviewModal from '../components/AttachmentsPreviewModal';
const { attachmentsPreviewModalClose } = actions;
const mapStateToProps = (state) => {
    return {
        fileName: state.attachmentsPreviewModal.fileName,
        url: state.attachmentsPreviewModal.url,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        closeModal: () => dispatch(attachmentsPreviewModalClose()),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(AttachmentsPreviewModal);
